export const CAR_IMAGE_WALKAROUND_KEYS = [
    "front",
    "frontRight",
    "rightSide",
    "rearRight",
    "rear",
    "rearLeft",
    "leftSide",
    "frontLeft",
];

export const CAR_IMAGE_DAMAGE_KEYS = ["damage1", "damage2", "damage3", "damage4", "damage5"];

export const CAR_IMAGE_OPTIONAL_KEYS = [...CAR_IMAGE_WALKAROUND_KEYS, "dashboard", ...CAR_IMAGE_DAMAGE_KEYS];

export const compactCarImages = (source) => {
    if (!source) return {};

    const compact = {};
    CAR_IMAGE_OPTIONAL_KEYS.forEach((key) => {
        const value = source[key];
        if (typeof value === "string" && value.trim()) {
            compact[key] = value.trim();
        }
    });

    return compact;
};

export const getImagesByKeys = (carImages, keys) =>
    keys.map((key) => carImages[key]).filter((value) => typeof value === "string" && value.trim());

export const getFuelLevelLabel = (level, t) => {
    if (level <= 25) return t("upcomingDetails.tripRecords.fuelEmpty");
    if (level <= 50) return t("upcomingDetails.tripRecords.fuelQuarter");
    if (level <= 75) return t("upcomingDetails.tripRecords.fuelHalf");
    if (level <= 87) return t("upcomingDetails.tripRecords.fuelThreeQuarters");
    return t("upcomingDetails.tripRecords.fuelFull");
};

export const formatFuelLevel = (level, t) => {
    if (level === null || level === undefined || level === "") return "—";

    const value = Number(level);
    if (Number.isNaN(value)) return "—";

    return `${Math.round(value)}% (${getFuelLevelLabel(value, t)})`;
};

export const formatOdometer = (mileage) => {
    if (mileage === null || mileage === undefined || mileage === "") return "—";

    const value = Number(mileage);
    if (Number.isNaN(value)) return "—";

    return `${Math.round(value).toLocaleString()} mi`;
};

export const buildTripRecordData = (record) => {
    const carImages = compactCarImages(record?.carImages);

    const walkaroundImages = getImagesByKeys(carImages, CAR_IMAGE_WALKAROUND_KEYS);
    const damageImages = getImagesByKeys(carImages, CAR_IMAGE_DAMAGE_KEYS);
    const dashboardImages = carImages.dashboard ? [carImages.dashboard] : [];
    const fuelLevel = record?.fuelLevel ?? null;
    const mileage = record?.mileage ?? null;

    const hasData =
        walkaroundImages.length > 0 ||
        damageImages.length > 0 ||
        dashboardImages.length > 0 ||
        fuelLevel ||
        mileage != null;

    return {
        walkaroundImages,
        damageImages,
        dashboardImages,
        fuelLevel,
        mileage,
        hasData,
    };
};
